document.addEventListener("DOMContentLoaded", function() {
  const wrappers = document.querySelectorAll('.collection-description-wrapper');

  wrappers.forEach(wrapper => {
    const descBox = wrapper.querySelector('.collection-description');
    const btn = wrapper.querySelector('.view-more-btn');

    if (!descBox || !btn) return;

    // 如果内容没超出两行，隐藏按钮
    if (descBox.scrollHeight <= descBox.clientHeight + 5) {
      btn.style.display = "none";
    }

    btn.addEventListener('click', function() {
      const expanded = descBox.classList.toggle('expanded');
      btn.textContent = expanded ? 'View Less' : 'View More';
      console.log("按钮被点击，当前状态:", expanded);
    });
  });
});
